module.exports = __webpack_public_path__ + "static/media/sun.bf3aed8d.png";